import { createAsyncThunk } from '@reduxjs/toolkit';
import moment from 'moment';
import { CommanderMonitoringFilterLogicalObject } from '../../../pages/AuthenticatedPages/Manager/ManagerPerformances/util/filter.model';
import { MonitoringService } from '../../../service/monitoring/MonitoringService';
import { ZipDeviceControlUnit } from '../../controlUnit/controlUnit.model';
import { getCUsTranslationsSelector } from '../../CUTranslation/selectors';
import { FeaturesActions } from '../../features/slice/FeaturesSlice';
import { ShowLevelOption } from '../../groups/selectors/getLevelOfView';
import { AppDispatch, RootState } from '../../store.model';
import { nameReducer } from '../monitoring.model';
import { FilterStoredProps, getPatchFilter } from '../selectors';
import { TEMPERATURE_UNIT_TYPES } from '../../../service/temperaturePreference';

export interface FetchMetricsArgs {
  devicesControlUnits: ZipDeviceControlUnit[];
  digitalFilterObjectEvents: CommanderMonitoringFilterLogicalObject;
  analogFilterObjectEvents: CommanderMonitoringFilterLogicalObject;
  start: number;
  end: number;
  showLevelOption: ShowLevelOption;
  temperaturePreference?: TEMPERATURE_UNIT_TYPES;
}

export const fetchMetrics = createAsyncThunk(
  `${nameReducer}/fetchSensorData`,
  (
    {
      devicesControlUnits,
      start,
      end,
      digitalFilterObjectEvents,
      analogFilterObjectEvents,
      showLevelOption,
      temperaturePreference,
    }: FetchMetricsArgs,
    thunkAPI
  ) => {
    const model = new MonitoringService();

    const CUsTranslate = getCUsTranslationsSelector(
      thunkAPI.getState() as RootState
    );

    const controlUnitState = (thunkAPI.getState() as RootState).controlUnit;
    return Promise.all([
      Promise.all(
        devicesControlUnits.map((deviceControlUnit) =>
          analogFilterObjectEvents[deviceControlUnit.deviceId]
            ? model.getSensordata(
                deviceControlUnit.deviceId,
                deviceControlUnit.commanderId,
                start,
                end,
                deviceControlUnit.deviceName ?? '',
                analogFilterObjectEvents[deviceControlUnit.deviceId] ?? {},
                CUsTranslate,
                showLevelOption,
                temperaturePreference
              )
            : Promise.resolve({})
        )
      ),
      Promise.all(
        devicesControlUnits.map((deviceControlUnit) =>
          digitalFilterObjectEvents[deviceControlUnit.deviceId]
            ? model.getDigitalChannels(
                deviceControlUnit.deviceId,
                deviceControlUnit.commanderId,
                moment(start).add(-1, 'day').valueOf(),
                moment(end).add(1, 'day').valueOf(),
                deviceControlUnit.deviceName ?? '',
                digitalFilterObjectEvents[deviceControlUnit.deviceId] ?? {},
                CUsTranslate,
                showLevelOption,
                controlUnitState
              )
            : Promise.resolve({})
        )
      ),
    ]);
  }
);

export const updateFilter =
  (
    props: FilterStoredProps & { value: CommanderMonitoringFilterLogicalObject }
  ) =>
  (dispatch: AppDispatch) => {
    const path = getPatchFilter(props);
    const stringValue = JSON.stringify(props.value);
    dispatch(FeaturesActions.updateFilter({ path, filter: stringValue }));
  };
